import {
  CLEAR_USER_STATE,
  IS_EMAIL_AVAILABLE_FAILURE,
  IS_EMAIL_AVAILABLE_REQUEST,
  IS_EMAIL_AVAILABLE_SUCCESS,
  IS_USERNAME_AVAILABLE_FAILURE,
  IS_USERNAME_AVAILABLE_REQUEST,
  IS_USERNAME_AVAILABLE_SUCCESS,
  UPDATE_USER_BASIC_PROFILE_FAILURE,
  UPDATE_USER_BASIC_PROFILE_REQUEST,
  UPDATE_USER_BASIC_PROFILE_SUCCESS,
} from "./ActionType";

const initialState = {
  isUsernameAvailableResult: {},
  isUsernameAvailableLoading: false,
  isUsernameAvailableError: null,

  isEmailAvailableResult: {},
  isEmailAvailableLoading: false,
  isEmailAvailableError: null,

  updateUserBasicProfileResult: {},
  updateUserBasicProfileLoading: false,
  updateUserBasicProfileError: null,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_USERNAME_AVAILABLE_REQUEST:
      return {
        ...state,
        isUsernameAvailableLoading: true,
        isUsernameAvailableError: null,
      };
    case IS_USERNAME_AVAILABLE_SUCCESS:
      return {
        ...state,
        isUsernameAvailableLoading: false,
        isUsernameAvailableResult: action.payload,
      };
    case IS_USERNAME_AVAILABLE_FAILURE:
      return {
        ...state,
        isUsernameAvailableLoading: false,
        isUsernameAvailableError: action.payload,
      };
    case IS_EMAIL_AVAILABLE_REQUEST:
      return {
        ...state,
        isEmailAvailableLoading: true,
        isEmailAvailableError: null,
      };
    case IS_EMAIL_AVAILABLE_SUCCESS:
      return {
        ...state,
        isEmailAvailableLoading: false,
        isEmailAvailableResult: action.payload,
      };
    case IS_EMAIL_AVAILABLE_FAILURE:
      return {
        ...state,
        isEmailAvailableLoading: false,
        isEmailAvailableError: action.payload,
      };
    case UPDATE_USER_BASIC_PROFILE_REQUEST:
      return {
        ...state,
        updateUserBasicProfileLoading: true,
        updateUserBasicProfileError: null,
      };
    case UPDATE_USER_BASIC_PROFILE_SUCCESS:
      return {
        ...state,
        updateUserBasicProfileLoading: false,
        updateUserBasicProfileResult: action.payload,
      };
    case UPDATE_USER_BASIC_PROFILE_FAILURE:
      return {
        ...state,
        updateUserBasicProfileLoading: false,
        updateUserBasicProfileError: action.payload,
      };
    case CLEAR_USER_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
